const currency_formatters = {
  usd: new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }),
  eur: new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }),
};

export const format_currency = (amount, currency) => {
  if (currency_formatters[currency]) {
    return currency_formatters[currency].format(amount);
  }
  return `${amount} ${currency}`;
};
